import React, { useState } from 'react';

interface Props {
  children: React.ReactNode;
  content: string;
  direction: string;
}

export const Tooltip: React.FC<Props> = ({ children, content, direction }) => {
  const [active, setActive] = useState<boolean>(false);

  return (
    <div
      className='tooltip-wrapper'
      data-testid='tooltip-wrapper'
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
    >
      {children}
      {active && content && (
        <div
          className={`tooltip-tip ${direction}`}
          data-testid='tooltip-tip'
        >
          {content}
        </div>
      )}
    </div>
  )
};